import { FONT_BASE_PX, FONT_CSS_VAR, useFontSettings } from '@/stores/fontSettings';
import { useEffect } from 'react';

/** Below this width the font-scale preferences apply (phone-sized screens only). */
const MOBILE_QUERY = '(max-width: 767px)';

/**
 * Applies the saved font scales, but ONLY on phone-sized screens so the desktop
 * experience is untouched:
 *  - listTitle / listItem → CSS px vars the trip surfaces read from.
 *  - appText → the root font size, so all other rem-based text scales globally.
 * Call once near the app root.
 */
export function useApplyFontScale(): void {
  const scales = useFontSettings((state) => state.scales);

  useEffect(() => {
    const mq = window.matchMedia(MOBILE_QUERY);
    const apply = () => {
      const mobile = mq.matches;
      const root = document.documentElement;
      root.style.setProperty(
        FONT_CSS_VAR.listTitle,
        `${FONT_BASE_PX.listTitle * (mobile ? scales.listTitle : 1)}px`,
      );
      root.style.setProperty(
        FONT_CSS_VAR.listItem,
        `${FONT_BASE_PX.listItem * (mobile ? scales.listItem : 1)}px`,
      );
      // Global "everything else": scale the root font size so all rem-based type
      // and spacing on other surfaces bump proportionally. Cleared on desktop.
      root.style.fontSize =
        mobile && scales.appText !== 1 ? `${FONT_BASE_PX.appText * scales.appText}px` : '';
    };
    apply();
    mq.addEventListener('change', apply);
    return () => mq.removeEventListener('change', apply);
  }, [scales]);
}
